import { useLocation, useNavigate } from "react-router-dom";
import { MessageSquarePlus } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Floating Action Button → opens the Feedback form.
 * Hidden on /login, /register, /track/* and on the feedback page itself.
 */
export function FeedbackFab() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  if (!user) return null;
  const path = location.pathname;
  if (
    path.startsWith("/feedback") ||
    path.startsWith("/admin/feedback") ||
    path.startsWith("/track/") ||
    // Full-canvas drawing routes: would overlap the toolbar buttons.
    path.endsWith("/sketch") ||
    path.endsWith("/annotate")
  ) return null;

  return (
    <button
      data-testid="feedback-fab"
      onClick={() => navigate("/feedback", { state: { fromPath: path } })}
      className="fixed bottom-6 right-4 z-40 h-12 px-4 rounded-full bg-[#18181B] border border-zinc-700 text-zinc-200 shadow-2xl hover:bg-zinc-800 hover:border-[#00E575]/60 hover:text-[#00E575] active:scale-95 transition-all flex items-center gap-2"
      aria-label="Feedback senden"
      title="Feedback senden"
    >
      <MessageSquarePlus size={18} />
      <span className="text-sm font-medium">Feedback</span>
    </button>
  );
}
